<template>
  <div class="admin">
    <v-alert dense text type="success">
      <strong>Ingreso Autorizado</strong>
    </v-alert>

    <!-- Aviso de la última versión publicada (#522). Si el índice no carga no se
         muestra nada: es informativo y nunca debe romper el inicio. -->
    <v-card
      v-if="ultimaVersion"
      elevation="2"
      class="rounded-xl pa-4 mb-4 novedades-banner"
      color="white"
      @click="navegarA('/novedades')"
    >
      <v-row no-gutters align="center">
        <v-col cols="auto" class="mr-4">
          <v-avatar size="44" color="teal lighten-4">
            <v-icon size="24" color="teal darken-1">mdi-bullhorn-outline</v-icon>
          </v-avatar>
        </v-col>
        <v-col class="novedades-banner__texto">
          <div class="font-weight-bold grey--text text--darken-3">
            Novedades de la versión {{ ultimaVersion.modulo }}
          </div>
          <div class="caption grey--text text--darken-1">
            {{ ultimaVersion.resumen || "Mirá todo lo que cambió en el sistema." }}
          </div>
        </v-col>
        <v-col cols="auto">
          <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
        </v-col>
      </v-row>
    </v-card>

    <v-row>
      <v-col cols="12" md="7">
        <v-card
          elevation="3"
          class="rounded-xl overflow-hidden welcome-card"
          color="white"
        >
          <v-row no-gutters align="center">
            <v-col cols="12" md="5" class="pa-8">
              <div class="welcome-text">
                <h1
                  class="text-h4 font-weight-bold grey--text text--darken-3 mb-2"
                >
                  ¡BIENVENIDO, {{ datosUser.nombre_completo }}!
                </h1>
                <p class="text-h6 grey--text text--darken-1">
                  Tu gestión eficiente comienza aquí
                </p>
              </div>
            </v-col>
            <v-col cols="12" md="7" class="pa-0">
              <v-img
                src="@/assets/inicio.png"
                class="welcome-illustration"
                contain
                max-height="350"
              ></v-img>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="5">
        <v-card elevation="2" class="rounded-xl pa-6" color="white">
          <v-row no-gutters align="center">
            <v-col cols="auto" class="mr-4">
              <v-avatar size="60" color="teal lighten-4">
                <v-icon size="35" color="teal darken-1">mdi-headset</v-icon>
              </v-avatar>
            </v-col>
            <v-col>
              <h3
                class="text-h6 font-weight-bold grey--text text--darken-3 mb-1"
              >
                Soporte Técnico
              </h3>
              <p class="text-body-2 grey--text text--darken-1 mb-3">
                ¿Necesitas ayuda? Haz click aquí para contactarnos.
              </p>
              <v-btn
                color="teal"
                dark
                rounded
                elevation="0"
                @click="contactarSoporte"
              >
                Contactar
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Publicidad: banner de la plataforma (no renderiza nada si no hay campaña) -->
    <BannerInicio />

    <!-- Accesos Rápidos -->
    <v-row class="mt-6">
      <v-col cols="12">
        <h2 class="text-h5 font-weight-bold grey--text text--darken-3 mb-4">
          <v-icon color="teal" class="mr-2">mdi-lightning-bolt</v-icon>
          Accesos Rápidos
        </h2>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-card
          elevation="4"
          class="rounded-xl pa-5 text-center quick-access-card"
          hover
          @click="navegarA('/pos')"
        >
          <v-avatar size="80" color="blue darken-1" class="mb-4">
            <v-icon size="45" color="white">mdi-point-of-sale</v-icon>
          </v-avatar>
          <h3
            class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1"
          >
            POS
          </h3>
          <p class="text-caption grey--text text--darken-1">Punto de Venta</p>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-card
          elevation="4"
          class="rounded-xl pa-5 text-center quick-access-card"
          hover
          @click="navegarA('/productos')"
        >
          <v-avatar size="80" color="orange darken-1" class="mb-4">
            <v-icon size="45" color="white">mdi-package-variant</v-icon>
          </v-avatar>
          <h3
            class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1"
          >
            Productos
          </h3>
          <p class="text-caption grey--text text--darken-1">
            Gestionar productos
          </p>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-card
          elevation="4"
          class="rounded-xl pa-5 text-center quick-access-card"
          hover
          @click="navegarA('/stock')"
        >
          <v-avatar size="80" color="green darken-1" class="mb-4">
            <v-icon size="45" color="white">mdi-warehouse</v-icon>
          </v-avatar>
          <h3
            class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1"
          >
            Stock
          </h3>
          <p class="text-caption grey--text text--darken-1">Control de stock</p>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-card
          elevation="4"
          class="rounded-xl pa-5 text-center quick-access-card"
          hover
          @click="navegarA('/pagos')"
        >
          <v-avatar size="80" color="indigo darken-1" class="mb-4">
            <v-icon size="45" color="white">mdi-cash-multiple</v-icon>
          </v-avatar>
          <h3
            class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1"
          >
            Pagos
          </h3>
          <p class="text-caption grey--text text--darken-1">Facturas y pagos</p>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-card
          elevation="4"
          class="rounded-xl pa-5 text-center quick-access-card"
          hover
          @click="navegarA('/admin-ventas')"
        >
          <v-avatar size="80" color="teal darken-1" class="mb-4">
            <v-icon size="45" color="white">mdi-receipt-text</v-icon>
          </v-avatar>
          <h3
            class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1"
          >
            Ventas
          </h3>
          <p class="text-caption grey--text text--darken-1">
            Ventas realizadas
          </p>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-card
          elevation="4"
          class="rounded-xl pa-5 text-center quick-access-card"
          hover
          @click="navegarA(rutaEstadisticas)"
        >
          <v-avatar size="80" color="pink darken-1" class="mb-4">
            <v-icon size="45" color="white">mdi-chart-line</v-icon>
          </v-avatar>
          <h3
            class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1"
          >
            Estadísticas
          </h3>
          <p class="text-caption grey--text text--darken-1">Ver reportes</p>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BannerInicio from "@/components/publicidad/BannerInicio.vue";
import novedadesService from "@/services/novedadesService";

export default {
  name: "Inicio",
  components: { BannerInicio },

  data() {
    return {
      datosUser: "",
      dataExcel: {},
      importansCards: [],
      generalsCards: [],
      accesosRapidos: [],
      ultimaVersion: null,
    };
  },

  computed: {
    esPuntoDeCobro() {
      return Boolean(this.$empresaConfig?.esPuntodeCobro);
    },
    rutaEstadisticas() {
      return this.esPuntoDeCobro ? "/estadisticas-pos" : "/estadisticas";
    },
  },

  mounted() {
    this.datosUser = JSON.parse(localStorage.getItem("token"));
    this.cargarAccesos();
    this.cargarUltimaVersion();
  },
  methods: {
    // El índice de novedades es un archivo estático del build: si falta o falla,
    // el banner simplemente no aparece.
    async cargarUltimaVersion() {
      try {
        const indice = await novedadesService.getIndice();
        this.ultimaVersion = Array.isArray(indice) && indice.length ? indice[0] : null;
      } catch (e) {
        this.ultimaVersion = null;
      }
    },

    contactarSoporte() {
      const mensaje = encodeURIComponent(
        "Hola, vengo de Punto de Cobro necesito soporte técnico. ¿Podrían ayudarme?"
      );
      window.open(`https://wa.me/+542645202530?text=${mensaje}`, "_blank");
    },
    navegarA(ruta) {
      this.$router.push(ruta).catch(() => {});
    },
    cargarAccesos() {
      // Cargar directamente del menú del usuario como lo hace Sidebar
      if (this.datosUser && this.datosUser.menu) {
        // Filtrar solo las rutas que queremos mostrar como accesos rápidos
        const rutasAccesosRapidos = [
          "/pos",
          "/productos",
          "/deposito",
          "/pagos",
          "/admin-ventas",
          "/estadisticas",
        ];

        this.accesosRapidos = this.datosUser.menu.filter((item) =>
          rutasAccesosRapidos.includes(item.ruta)
        );

      }
    },
    obtenerColor(ruta) {
      // Mapeo de colores según la ruta
      const colores = {
        "/pos": "blue darken-1",
        "/productos": "orange darken-1",
        "/deposito": "green darken-1",
        "/pagos": "indigo darken-1",
        "/admin-ventas": "teal darken-1",
        "/estadisticas": "pink darken-1",
      };
      return colores[ruta] || "grey darken-1";
    },
    obtenerDescripcion(ruta) {
      // Mapeo de descripciones según la ruta
      const descripciones = {
        "/pos": "Punto de Venta",
        "/productos": "Gestionar productos",
        "/deposito": "Control de stock",
        "/pagos": "Facturas y pagos",
        "/admin-ventas": "Ventas realizadas",
        "/estadisticas": "Ver reportes",
      };
      return descripciones[ruta] || "";
    },
  },
};
</script>

<style>
.welcome-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  border-left: 5px solid #4db6ac;
}

.welcome-text {
  animation: fadeInLeft 0.6s ease-out;
}

.welcome-illustration {
  animation: fadeInRight 0.6s ease-out;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.quick-access-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: 2px solid transparent;
  background: white;
}

.quick-access-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2) !important;
  border-color: rgba(0, 150, 136, 0.3);
}

.quick-access-card .v-avatar {
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.quick-access-card:hover .v-avatar {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}
</style>
